


// // src/pages/Login.jsx
// import React, { useState } from "react";
// import { useAuth } from "../context/AuthContext";
// import { useNavigate, Link } from "react-router-dom";
// import Logo from './image/logo.png';
// import '../style/Login.css';

// const Login = () => {
//   const { login } = useAuth();
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [tenantId, setTenantId] = useState(""); // opcional para desarrollador
//   const [sedeId, setSedeId] = useState(""); // opcional si aplica
//   const [formError, setFormError] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault(); // 🔹 Evitar recarga

//     if (!username.trim() || !password.trim()) {
//       setFormError("⚠️ Todos los campos son obligatorios");
//       return;
//     }

//     setFormError("");

//     try {
//       const result = await login(username, password, { tenant_id: tenantId || null, sede_id: sedeId || null });

//       if (result.ok) {
//         const { user } = result;

//         switch (user?.role) {
//           case "rector":
//             navigate("/dashboard-rector");
//             break;
//           case "profesor":
//             navigate("/dashboard-profesor");
//             break;
//           case "estudiante":
//             navigate("/dashboard-estudiante");
//             break;
//           case "secretaria":
//             navigate("/dashboard-secretaria");
//             break;
//           case "desarrollador":
//             navigate("/dashboard-desarrollador");
//             break;
//           default:
//             navigate("/");
//         }
//       } else {
//         setFormError(result.message || "❌ Error al iniciar sesión");
//       }
//     } catch (err) {
//       console.error("Login error:", err);
//       setFormError("❌ Error de conexión con el servidor");
//     }
//   };

//   return (
//     <div className="login-container">
//       <div className="login-card">
//         <div className="login-header">
//           <img src={Logo} alt="Barzillai" className="login-logo" />
//           <h1 className="login-title">Barzillai</h1>
//         </div>

//         <h2 className="login-subtitle">Iniciar Sesión</h2>

//         <form onSubmit={handleLogin}>
//           <input
//             type="text"
//             value={username}
//             onChange={(e) => setUsername(e.target.value)}
//             placeholder="Usuario (documento)"
//             className="login-input"
//             autoComplete="username"
//           />
//           <input
//             type="password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             placeholder="Contraseña"
//             className="login-input"
//             autoComplete="current-password"
//           />
//           <input
//             type="text"
//             value={tenantId}
//             onChange={(e) => setTenantId(e.target.value)}
//             placeholder="Tenant ID (solo roles con tenant)"
//             className="login-input"
//           />
//           <input
//             type="text"
//             value={sedeId}
//             onChange={(e) => setSedeId(e.target.value)}
//             placeholder="Sede ID (opcional)"
//             className="login-input"
//           />

//           <button type="submit" className="login-button">
//             Ingresar
//           </button>
//           {formError && <p className="login-warning">{formError}</p>}
//         </form>

//         <p className="login-register">
//           ¿No tienes cuenta?{" "}
//           <Link to="/register" className="login-link">
//             Regístrate aquí
//           </Link>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Login;


//
// src/pages/Login.jsx
import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import Logo from "./image/logo.png";
import "../style/Login.css";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [formError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username.trim() || !password.trim()) {
      setFormError("⚠️ Documento y contraseña son obligatorios");
      return;
    }

    setLoading(true);
    setFormError("");

    const result = await login(username, password);
    setLoading(false);

    if (!result.ok) {
      setFormError(result.message || "❌ Error al iniciar sesión");
      return;
    }

    // 👨‍👩‍👧 PADRE CON MÚLTIPLES CONTEXTOS
    if (result.multiple) {
      navigate("/seleccionar-contexto", {
        state: {
          documento: username,
          opciones: result.opciones
        }
      });
      return;
    }

    // 🔁 LOGIN NORMAL
    const role = result.user?.role;

const routes = {
  rector: "/dashboard-rector",
  coordinador: "/dashboard-rector",
  secretaria: "/dashboard-admin",   // 👈 AQUI
  profesor: "/dashboard-profesor",
  estudiante: "/dashboard-estudiante",
  padre: "/dashboard-padre",
  desarrollador: "/dashboard-dev"
};


    navigate(routes[role] || "/");
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src={Logo} alt="Barzillai" className="login-logo" />
          <h1 className="login-title">Barzillay</h1>
        </div>

        <h2 className="login-subtitle">Iniciar Sesión</h2>

        <form onSubmit={handleLogin}>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Documento"
            className="login-input"
            autoComplete="username"
          />

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Contraseña"
            className="login-input"
            autoComplete="current-password"
          />

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Ingresando..." : "Ingresar"}
          </button>

          {formError && <p className="login-warning">{formError}</p>}
        </form>

        {/* <p className="login-register">
          ¿No tienes cuenta?{" "}
          <Link to="/register" className="login-link">
            Regístrate aquí
          </Link>
        </p> */}
      </div>
    </div>
  );
};

export default Login;
